import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enJSON from './locale/en.json';
import enErrors from './locale/errors.en.json';
import inviteTeamMember from './locale/inviteTeamMember.json';
import nonUsSocure from './locale/nonUsSocure.json';
import emailMfaEnJson from './locale/emailMfa.en.json';
import esJSON from './locale/es.json';

import uboOnboarding from './locale/uboOnboarding.json';
import eddQuestions from './locale/eddQuestions.json';
import cddQuestions from './locale/cddQuestions.json';
export const defaultNS = 'enJSON';

export const resources = {
  en: {
    enJSON,
    enErrors,
    inviteTeamMember,
    nonUsSocure,
    emailMfaEnJson,
    uboOnboarding,
    eddQuestions,
    cddQuestions,
    esJSON,
  },
  es: {
    esJSON,
  },
} as const;

i18next.use(initReactI18next).init({
  resources,
  interpolation: {
    escapeValue: false,
  },
  defaultNS: defaultNS,
  lng: 'en',
  ns: [
    'enJSON',
    'enErrors',
    'inviteTeamMember',
    'nonUsSocure',
    'eddQuestions',
    'cddQuestions',
    'uboOnboarding',
    'emailMfaEnJson',
    'esJSON',
  ], // Specify the namespaces to use
});

export default i18next;
